import { StepIndicator } from 'components/layout/StepIndicator';
import { URLS } from 'config';
import { useMemo } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { QUERY_URLS, QUOTE_URLS } from '../constants';
import { QUERY_STEPS, QUOTE_STEPS } from './constants';

export interface EnquiryStepsHook {
  steps: StepIndicator[] | undefined;
}

export default function useEnquirySteps(isLoading = false): EnquiryStepsHook {
  const { pathname } = useLocation();

  const onLanding = useMemo(() => {
    if (isLoading) return false;
    return Boolean(
      matchPath(pathname, {
        path: URLS.enquiry,
        exact: true,
        strict: true,
      }),
    );
  }, [pathname, isLoading]);

  const onQuery = useMemo(() => {
    if (isLoading) return true;
    return QUERY_URLS.some((path) =>
      Boolean(
        matchPath(pathname, {
          path,
          exact: true,
          strict: true,
        }),
      ),
    );
  }, [pathname, isLoading]);

  const onQuote = useMemo(() => {
    if (isLoading) return true;
    return QUOTE_URLS.some((path) =>
      Boolean(
        matchPath(pathname, {
          path,
          exact: true,
          strict: true,
        }),
      ),
    );
  }, [pathname, isLoading]);

  const steps = useMemo(() => {
    if (onLanding) return undefined;
    if (onQuery) return QUERY_STEPS;
    if (onQuote) return QUOTE_STEPS;
    return undefined;
  }, [onLanding, onQuery, onQuote]);

  return {
    steps,
  };
}
